import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs'
})
export class AbsPipe implements PipeTransform {

  transform(value: number, args?: any): number {
    if(value === 0) return  0;
    return Math.abs(value);
  }

}
